import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { ZapIcon, LockIcon, TrendingDownIcon } from 'lucide-react';
const reasons = [{
  icon: ZapIcon,
  title: 'Speed & Agility',
  description: 'Small teams can move fast, exploit micro edges, and maintain secrecy.'
}, {
  icon: LockIcon,
  title: 'Illiquid Markets',
  description: 'Many strategies live in illiquid or quirky markets without institutional capacity.'
}, {
  icon: TrendingDownIcon,
  title: 'Alpha Preservation',
  description: 'Each niche has limited upside — bigger groups dilute alpha and slow iteration.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 40,
    scale: 0.95
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function WhySmall() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  return <section ref={ref} className="w-full py-32 px-6 bg-navy-900" data-id="element-413">
      <div className="max-w-6xl mx-auto" data-id="element-414">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={inView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-4xl md:text-5xl font-bold mb-16 text-center text-white" data-id="element-415">
          Why Stay Small
        </motion.h2>
        <motion.div variants={containerVariants} initial="hidden" animate={inView ? 'visible' : 'hidden'} className="grid md:grid-cols-3 gap-6" data-id="element-416">
          {reasons.map((reason, index) => {
          const Icon = reason.icon;
          return <motion.div key={reason.title} variants={itemVariants} whileHover={{
            y: -8,
            scale: 1.02,
            boxShadow: '0 20px 40px rgba(30, 58, 138, 0.3)',
            transition: {
              duration: 0.3
            }
          }} className="bg-navy-800 border-2 border-navy-700 rounded-lg p-6 hover:border-steel transition-all duration-300 shadow-lg" data-id="element-417">
                <motion.div initial={{
              scale: 0,
              rotate: -90
            }} animate={inView ? {
              scale: 1,
              rotate: 0
            } : {}} transition={{
              duration: 0.5,
              delay: 0.4 + index * 0.1
            }} className="mb-4 w-12 h-12 bg-navy-700 rounded-lg flex items-center justify-center" data-id="element-418">
                  <Icon className="w-6 h-6 text-white" data-id="element-419" />
                </motion.div>
                <h3 className="text-xl font-bold mb-3 text-white" data-id="element-420">
                  {reason.title}
                </h3>
                <p className="text-slate leading-relaxed text-sm" data-id="element-421">
                  {reason.description}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}